// ============================================================
// TN FOOD — Prestations traiteur : formules, tarifs, FAQ
// ============================================================

export const eventTypes = [
  { icon: "Heart", title: "Mariages", description: "Buffets, cocktails dînatoires, service à table, pièce montée de pâtisseries orientales." },
  { icon: "Gem", title: "Fiançailles", description: "Cérémonies familiales et réceptions de fiançailles sur mesure." },
  { icon: "Cake", title: "Anniversaires", description: "Anniversaires et fêtes de famille, en petit ou grand comité." },
  { icon: "Baby", title: "Baptêmes", description: "Baptêmes et circoncisions, buffets doux et festifs." },
  { icon: "Briefcase", title: "Entreprise", description: "Séminaires, inaugurations, pots de départ, plateaux repas." },
  { icon: "Users", title: "Fêtes familiales", description: "Fêtes familiales et religieuses : Aïd, Ramadan (repas après la rupture du jeûne)." },
  { icon: "UtensilsCrossed", title: "Buffets", description: "Buffets froids et chauds, composés selon vos envies." },
  { icon: "Coffee", title: "Pauses gourmandes", description: "Pauses café et pauses gourmandes pour vos réunions." },
];

export const formules = [
  { title: "Cocktail dînatoire", description: "15 à 25 pièces salées et sucrées par personne, service en buffet ou en circulation." },
  { title: "Buffet froid", description: "Entrées variées, salades, charcuteries, fromages, pains." },
  { title: "Buffet chaud", description: "Plats mijotés tunisiens, grillades, accompagnements." },
  { title: "Repas assis (service à table)", description: "Entrée + plat + dessert, service par notre personnel." },
  { title: "Plateau repas individuel", description: "Pour événements professionnels, livré prêt à consommer." },
  { title: "Thé & pâtisseries orientales", description: "Pour les cérémonies et réceptions." },
  { title: "Personnalisation", description: "Chaque prestation est adaptée selon vos envies, votre budget et le nombre de convives." },
];

export const prestationsComplementaires = [
  "Livraison sur lieu d'événement (toute la France)",
  "Personnel de service (maîtres d'hôtel, serveurs, plongeurs)",
  "Location de matériel : vaisselle, verrerie, nappage, tables, chaises, barnums",
  "Décoration de table (thème oriental, mariage, etc.)",
  "Animation musicale et DJ (partenaire externe)",
];

export const tarifs = [
  { label: "Cocktail dînatoire (15 pièces/personne)", price: "22 € à 28 € HT / personne" },
  { label: "Cocktail dînatoire (20 pièces/personne)", price: "28 € à 35 € HT / personne" },
  { label: "Buffet froid complet", price: "28 € à 38 € HT / personne" },
  { label: "Buffet chaud avec plats traditionnels", price: "32 € à 45 € HT / personne" },
  { label: "Repas assis 3 services avec service à table", price: "40 € à 60 € HT / personne" },
  { label: "Plateau repas individuel professionnel", price: "15 € à 22 € HT / personne" },
  { label: "Formule thé et pâtisseries orientales", price: "12 € à 18 € HT / personne" },
  { label: "Personnel de service", price: "25 € à 35 € HT / heure et par serveur (min. 4 h)" },
  { label: "Livraison", price: "0,80 € à 1,50 € HT / km depuis Sainte-Savine (A/R), min. 30 €" },
  { label: "Location vaisselle et matériel", price: "Sur devis selon les quantités" },
];

export const minimums =
  "Minimum de commande : 20 personnes pour les buffets et cocktails, 15 personnes pour les plateaux repas individuels, 30 personnes pour le service à table.";

export const tarifsNote =
  "Les tarifs indiqués sont indicatifs et dépendent du type de prestation, du nombre de convives, de la saison et des options retenues. Un devis personnalisé vous sera adressé sous 48 heures ouvrées.";

export const faq = [
  {
    q: "Quels types d'événements couvrez-vous ?",
    a: "Mariages, fiançailles, anniversaires, baptêmes, événements d'entreprise, fêtes religieuses et familiales.",
  },
  {
    q: "Intervenez-vous en dehors de Troyes ?",
    a: "Oui, nous intervenons dans toute la France, au départ de notre cuisine de Sainte-Savine.",
  },
  {
    q: "Quel est le nombre minimum de convives ?",
    a: "20 personnes pour les buffets et cocktails, 15 pour les plateaux repas, 30 pour le service à table.",
  },
  {
    q: "Proposez-vous des dégustations ?",
    a: "Oui, une dégustation peut être organisée sur rendez-vous pour les mariages et événements importants, sur devis.",
  },
  {
    q: "Prenez-vous en charge le service à table ?",
    a: "Oui, notre personnel de service peut être mis à votre disposition. Tarification à l'heure.",
  },
  {
    q: "Fournissez-vous la vaisselle et le matériel ?",
    a: "Oui, location possible de vaisselle, verrerie, nappage, tables, chaises et barnums.",
  },
  {
    q: "Prenez-vous en compte les allergies et régimes spécifiques ?",
    a: "Oui, signalez-nous toute allergie ou régime particulier au moment du devis. Nous adapterons les menus.",
  },
  {
    q: "Quels sont les délais à respecter pour réserver ?",
    a: "Nous recommandons de réserver au minimum 4 à 6 semaines à l'avance pour un mariage, 2 semaines pour les autres événements.",
  },
  {
    q: "Comment se passe le paiement ?",
    a: "30 % d'acompte à la réservation, solde 7 jours avant l'événement. Virement bancaire ou carte bancaire.",
  },
  {
    q: "Que se passe-t-il en cas d'annulation ?",
    a: "Annulation à plus de 30 jours : remboursement de l'acompte déduction faite des frais engagés. Annulation à moins de 30 jours : acompte retenu. Annulation à moins de 7 jours : totalité due.",
  },
];

export const methode = [
  { step: 1, title: "Vous nous contactez", description: "Par téléphone, email ou via le formulaire de devis en ligne." },
  { step: 2, title: "Nous échangeons sur votre projet", description: "Type d'événement, nombre de convives, envies, budget." },
  { step: 3, title: "Vous recevez un devis personnalisé", description: "Sous 48 heures ouvrées, détaillé et sans engagement." },
  { step: 4, title: "Nous organisons la prestation le jour J", description: "Livraison, mise en place, service : nous nous occupons de tout." },
];
